import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { atomFamily } from 'jotai-family';
import { Temporal } from 'temporal-polyfill';
import { IInvestmentDataModel } from '../../../data-models/investment.data-model';
import { fetchRoundTracker } from '../../../services/queries/MaggieMetricsQueries';

export const RoundTrackerQueryKey = 'roundTrackerQuery';

export const roundTrackerMetricsByDateAtom = atomFamily(
  ({
    date,
    currency,
    fundIds,
    includeNonParticipatingRounds,
  }: {
    date: Temporal.PlainDate;
    currency: string;
    fundIds?: number[];
    includeNonParticipatingRounds?: boolean;
  }) =>
    atomWithQuery(() => ({
      queryKey: [
        RoundTrackerQueryKey,
        date.toString(),
        currency,
        fundIds === undefined ? undefined : [...fundIds].sort(),
        includeNonParticipatingRounds,
      ],
      queryFn: async () => {
        return (
          await fetchRoundTracker(
            date.toString(),
            currency,
            undefined,
            fundIds,
            includeNonParticipatingRounds
          )
        ).filter((metric) => {
          return Temporal.PlainDate.compare(metric.investmentDate, date) < 0;
        });
      },
      staleTime: Infinity,
      throwOnError: true,
    })),
  (a, b) =>
    a.date.equals(b.date) &&
    a.currency === b.currency &&
    a.includeNonParticipatingRounds === b.includeNonParticipatingRounds &&
    JSON.stringify(a.fundIds === undefined ? undefined : [...a.fundIds].sort()) ===
      JSON.stringify(b.fundIds === undefined ? undefined : [...b.fundIds].sort())
);

export const roundTrackerMetricsFilteredByViewAtom = atomFamily((_viewId: number) => {
  return atom([] as IInvestmentDataModel[]);
});
